import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {ConditionGroup, SegmentAccountCountResponse} from "./types";

export type CountSegmentAccountsVariables = {
  conditions: ConditionGroup;
  segmentId?: number;
};

const countSegmentAccounts = async ({
  conditions,
  segmentId,
}: CountSegmentAccountsVariables): Promise<SegmentAccountCountResponse> => {
  const response = await axiosReachInstance.post<
    SegmentAccountCountResponse,
    AxiosResponse<SegmentAccountCountResponse>,
    ConditionGroup
  >("/segments/count", conditions, {params: {segment_id: segmentId}});
  return response.data;
};

export const useCountSegmentAccounts = (
  options?: BaseMutationOptions<SegmentAccountCountResponse, CountSegmentAccountsVariables>
): BaseUseMutationResult<SegmentAccountCountResponse, CountSegmentAccountsVariables> => {
  return useBaseMutation<SegmentAccountCountResponse, CountSegmentAccountsVariables>(countSegmentAccounts, options);
};
